const directive = require.context('@/directives', true, /\.js$/)

export default (Vue, options) => {
  directive.keys().forEach((path) => {
    const file = directive(path).default
    const key = path.replace(/(\.\/)(\w{1,})(\.js)/, '$2')
    Vue.directive(key, file)
  })
}
